import classNames from "classnames";
import { QuestionMarkIllustration } from "../AscIllustrations";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import styles from "./AscRewardEmptyBox.module.scss";

export interface AscRewardEmptyBoxProps {
  title: string;
  subtitle?: string;
  className?: string;
}

export default function AscRewardEmptyBox({
  title = "No items",
  subtitle,
  className,
}: AscRewardEmptyBoxProps) {
  return (
    <div
      data-testid="asc-reward-empty-box"
      className={classNames(styles.emptyBoxWrapper, className)}
    >
      <div className={styles.emptyBox}>
        <QuestionMarkIllustration />
        <span className={styles.emptyBoxTitle}>{title}</span>
        {subtitle && (
          <AscParagraph className={styles.emptyBoxSubtitle}>
            {subtitle}
          </AscParagraph>
        )}
      </div>
    </div>
  );
}
